import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { useMember } from '~/components/Member/Member.hooks';
import { UseDosiminQueryOptions } from '~/components/Query/Query.hooks';

export const balanceUrl = '/api/citizen/v1/balance';

export type Balance = {
  assetType: string;
  amount: number;
};

export const getBalance = async () => {
  const { data } = await axios.get<Balance>(balanceUrl);
  return data;
};
export const useBalance = (options?: UseDosiminQueryOptions<Balance>) => {
  const {
    data: { isLoggedIn },
  } = useMember();
  return useQuery<Balance>(['balance'], getBalance, {
    enabled: !!isLoggedIn,
    initialData: {
      assetType: 'DON',
      amount: 0,
    },
    initialDataUpdatedAt: 0,
    ...options,
  });
};
